import * as d3 from 'd3'

function createLink (dataBus, svg, linkList) {
    let {
        svgPadding,
        cellWidth,
        cellHeight,
        duration
    } = dataBus.graphConfig
    // create group link
    let gLink = svg.select('.g-link')
    if (gLink.empty()) {
        gLink = svg.append('g').attr('class', 'g-link')
            .attr('transform', `translate(${svgPadding},${svgPadding})`)
    }
    let gLinkSelection = gLink.selectAll('path').data(linkList, d => d.id)
    let gLinkEnter = gLinkSelection.enter()
        .append('path')
        .attr('id', d => 'link-' + d.id)
        .attr('class', 'link')
        .attr('d', d => {
            return getLinkRoot(dataBus.openNode, cellWidth, cellHeight)
        })
    gLinkEnter.append('title')
        .text(d => `${d.source.name} --> ${d.target.name}`)
    gLinkEnter.merge(gLinkSelection)
        .transition()
        .duration(duration)
        .attr('d', d => getLinkD(d, dataBus))
    gLinkSelection.exit()
        .transition()
        .duration(duration)
        .attr('d', () => {
            return getLinkRoot(dataBus.closeNode, cellWidth, cellHeight)
        })
        .remove()
}

function getLinkRoot (root, cellWidth, cellHeight) {
    let openNode = root || {
        x: -1,
        y: -1
    }
    let source = {
        x: openNode.x * cellWidth + cellWidth / 2,
        y: openNode.y * cellHeight + cellHeight / 2
    }
    return d3.linkHorizontal()({
        source: [source.x, source.y],
        target: [source.x, source.y]
    })
}

function getLinkD (d, dataBus) {
    let {
        rectWidth,
        circleRadius,
        cellWidth,
        cellHeight
    } = dataBus.graphConfig
    let sourceWidth2 = d.source.type === 'STEP' ? rectWidth / 2 : circleRadius
    let targetWidth2 = d.target.type === 'STEP' ? rectWidth / 2 : circleRadius
    let source = {
        x: d.source.x * cellWidth + cellWidth / 2 + sourceWidth2,
        y: d.source.y * cellHeight + cellHeight / 2
    }
    let target = {
        x: d.target.x * cellWidth + cellWidth / 2 - targetWidth2,
        y: d.target.y * cellHeight + cellHeight / 2
    }
    return d3.linkHorizontal()({
        source: [source.x, source.y],
        target: [target.x, target.y]
    })
}

export default createLink
